import React from 'react';
import { Container, Typography, Box } from '@mui/material';

function LandingPage() {
    return (
        <Container maxWidth="md" sx={{ mt: 8, textAlign: 'center' }}>
            <img src="/HAX_logo.png" alt="HAX Platform Logo" style={{ maxWidth: '100%', marginBottom: '16px' }} />
            <Typography variant="h2" component="h1" gutterBottom>
                HAX Platform
            </Typography>
            <Typography variant="h5" component="h2" gutterBottom>
                The Future of Experimentation
            </Typography>
            <Box sx={{ mt: 4, border: '2px solid', borderColor: 'primary.main', p: 4, borderRadius: 2 }}>
                <Typography variant="body1">
                    Welcome to the HAX Platform, where cutting-edge technology meets innovative experimentation.
                </Typography>
            </Box>
        </Container>
    );
}

export default LandingPage;